// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"380":"a2d2e7c9","381":"c4449140","861":"e3b35630"}[chunkId] + ".chunk.js";
};